import internalProjects from "./internal-projects-reducer";
import externalProjects from "./external-projects-reducer";
import team from "./team-reducer";

export default {
  internalProjects,
  externalProjects,
  team
};
